var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "108.47 201.4 273.64 202.57 326.84 268.08 55.92 268.08 108.47 201.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.69,
    y: 268.08,
    width: 240.27,
    height: 201.37,
    transform: "translate(375.66 737.53) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.67 230.89 180.99 252.01 123.77 252.01 123.77 230.89 148.74 185.57 180.99 230.5 193.67 230.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.77,
    y: 398.36,
    width: 9.15,
    height: 71.09,
    transform: "translate(102.7 867.81) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.35,
    y: 410.36,
    width: 24.95,
    height: 59.09,
    transform: "translate(267.66 879.81) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.03,
    cy: 222.93,
    r: 9.33,
    transform: "translate(-113.4 172.09) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.85,
    y: 398.36,
    width: 9.15,
    height: 71.09,
    transform: "translate(312.85 867.81) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.07,443.18a1.29,1.29,0,1,0,1.29-1.29A1.29,1.29,0,0,0,124.07,443.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,355.84c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,355.72,67.69,355.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,363c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,362.83,67.69,363Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,370.06c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,369.94,67.69,370.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,377.17c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22S253.72,377,187.53,377,67.69,377.05,67.69,377.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,384.28c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,384.16,67.69,384.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,391.39c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,391.26,67.69,391.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,398.5c0,.12,53.66.22,119.84.22s119.84-.1,119.84-.22-53.65-.23-119.84-.23S67.69,398.37,67.69,398.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,405.6c0,.13,53.66.23,119.84.23s119.84-.1,119.84-.23-53.65-.22-119.84-.22S67.69,405.48,67.69,405.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.41,
    y: 281.9,
    width: 60.09,
    height: 62.32,
    transform: "translate(294.9 626.13) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,344.22s0-.1,0-.3v-.86c0-.78,0-1.9,0-3.36,0-2.95,0-7.24,0-12.7,0-10.91.06-26.46.1-45.1l-.19.2,60.08,0h0l-.22-.23c0,22.87,0,44.27,0,62.32l.19-.19-43.52.1-12.22.05-3.23,0h0l3.19,0,12.18.05,43.64.1h.19v-.2c0-18.05,0-39.45,0-62.32v-.22h-.23l-60.08,0h-.2v.19c0,18.69.08,34.28.1,45.23,0,5.43,0,9.71,0,12.65,0,1.44,0,2.55,0,3.32,0,.36,0,.64,0,.84S117.41,344.22,117.41,344.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31,343.37c.12,0,.22-13.67.22-30.53s-.1-30.54-.22-30.54-.23,13.67-.23,30.54S146.18,343.37,146.31,343.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,315.06c0,.12,13.15.22,29.38.22s29.39-.1,29.39-.22-13.16-.22-29.39-.22S118.07,314.94,118.07,315.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.91,
    y: 295.26,
    width: 18.55,
    height: 36.35,
    transform: "translate(184.36 626.87) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,331.61a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.52,0-.49,0-1.17,0-2,0-1.78,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.54c.06,0-.42-.42-.22-.21h0v5.17c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.16-.17-13.51.09-3.71.05h-1l-.34,0a1.64,1.64,0,0,0,.31,0l1,0,3.67,0,13.61.09h.17v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6,0-1.66,0-3.34,0-5.05v-5.17h0c.2.19-.27-.29-.23-.24l-18.54,0H82.7v.21c0,10.63.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2v.51C82.9,331.56,82.9,331.62,82.91,331.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,331.59c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S92,331.59,92.12,331.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12,314.7c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S83.12,314.57,83.12,314.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.44,
    y: 295.26,
    width: 18.55,
    height: 36.35,
    transform: "translate(407.42 626.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.44,331.61a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.52,0-.49,0-1.17,0-2,0-1.78,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21H213c.06,0-.42-.42-.22-.21h0v5.17c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.17-.17-13.52.09-3.71.05h-1l-.34,0a1.64,1.64,0,0,0,.31,0l.95,0,3.67,0,13.62.09h.16v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6V295.28h0c.2.19-.27-.29-.23-.24l-18.54,0h-.21v.21c0,10.63.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2,0,.21,0,.38,0,.51S194.43,331.62,194.44,331.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,331.59c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S203.53,331.59,203.65,331.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,314.7c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S194.65,314.57,194.65,314.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.29,
    y: 411.87,
    width: 18.55,
    height: 36.35,
    transform: "translate(355.12 860.09) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,448.22a1.49,1.49,0,0,0,0-.19c0-.14,0-.31,0-.53,0-.48,0-1.16,0-2,0-1.79,0-4.34.06-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.54l-.22-.22v5.19c0,1.71,0,3.39,0,5.05,0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.16-.17-13.51.09-3.71,0-1,0a2.3,2.3,0,0,0-.34,0,1.64,1.64,0,0,0,.31,0l1,0,3.67,0,13.61.09H187v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6,0-1.66,0-3.34,0-5.05v-5.19l-.23-.23-18.54,0h-.21v.21c0,10.62.07,19.73.1,26.21,0,3.18,0,5.72.06,7.49,0,.85,0,1.51,0,2,0,.21,0,.37,0,.51S168.28,448.22,168.29,448.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,448.2c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.22,8.18-.22,18.27S177.38,448.2,177.5,448.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,431.31c0,.12,4.19.22,9.37.22s9.36-.1,9.36-.22-4.19-.23-9.36-.23S168.5,431.18,168.5,431.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.57,
    y: 411.87,
    width: 18.55,
    height: 36.35,
    transform: "translate(195.7 860.09) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,448.22a.76.76,0,0,0,0-.19c0-.14,0-.31,0-.53l0-2c0-1.79,0-4.34.05-7.54,0-6.45.06-15.5.1-26.07l-.21.21h18.55l-.22-.22v10.24c0,3.32,0,6.53,0,9.6,0,6.14,0,11.72,0,16.51l.17-.17-13.51.09-3.71,0-1,0-.35,0,.32,0,.94,0,3.68,0,13.61.09h.17v-.17c0-4.79,0-10.37,0-16.51,0-3.07,0-6.28,0-9.6v-5.05c0-.86,0-1.72,0-2.58v-2.61l-.23-.23-18.55,0h-.21v.21c0,10.62.08,19.73.11,26.21,0,3.18,0,5.72,0,7.49l0,2v.51C88.57,448.17,88.57,448.22,88.57,448.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.79,448.2c.12,0,.22-8.18.22-18.27s-.1-18.27-.22-18.27-.23,8.18-.23,18.27S97.66,448.2,97.79,448.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79,431.31c0,.12,4.19.22,9.36.22s9.37-.1,9.37-.22-4.19-.23-9.37-.23S88.79,431.18,88.79,431.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,469.45c.13,0,.23-16.53.23-36.93s-.1-36.92-.23-36.92-.22,16.53-.22,36.92S232.46,469.45,232.58,469.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,343.37a3.54,3.54,0,0,0,0-.5c0-.37,0-.82,0-1.39,0-1.24.05-2.94.08-5l-.15.15c4.62,0,11.27.07,18.65.07l-.22-.22h0V340c0,1.16,0,2.29,0,3.37l.21-.21c-5.34,0-10,.06-13.3.1l-3.9.06-1.07,0-.38,0a1.2,1.2,0,0,0,.33,0l1,0,3.86.06c3.31,0,8,.09,13.44.1h.22v-.22c0-1.08,0-2.21,0-3.37v-3.54h0l-.23-.23c-7.38,0-14,0-18.65.07h-.16v.15c0,2.13.06,3.87.08,5.13,0,.55,0,1,0,1.36A2.23,2.23,0,0,0,220.66,343.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,288.1a4.37,4.37,0,0,0,0-.48c0-.35,0-.78,0-1.3,0-1.17,0-2.74.09-4.65l-.17.16,13.45.06-.22-.22h0v1.66c0,.55,0,1.1,0,1.63v3.12l.22-.22c-3.88,0-7.21.07-9.6.11L105,288a8,8,0,0,0-1,.06,9.21,9.21,0,0,0,1,0l2.77.06c2.37,0,5.77.08,9.74.1h.21v-.21c0-1,0-2,0-3.12v-3.29h0l-.23-.23L104,281.5h-.17v.16c0,1.95.06,3.55.09,4.75l0,1.26A2,2,0,0,0,104,288.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.73,
    y: 343.37,
    width: 18.05,
    height: 6.59,
    transform: "translate(435.5 693.33) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.57,
    y: 288.48,
    width: 18.05,
    height: 6.59,
    transform: "translate(391.18 583.54) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.45,
    y: 337.38,
    width: 18.05,
    height: 6.59,
    transform: "translate(216.94 681.34) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.69,
    y: 313.06,
    width: 15.03,
    height: 6.59,
    transform: "translate(150.42 632.72) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.58 398.72 34.78 398.72 77.82 363.18 184.87 363.18 232.58 398.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.67 230.89 204.02 230.89 168.19 181.12 145.56 181.36 180.99 230.5 193.67 230.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.77 230.89 116.86 230.89 145.56 181.36 148.74 185.57 123.77 230.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.99 252.01 180.99 230.53 193.67 230.53 180.99 252.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.87 363.18 147.41 398.72 232.86 398.72 184.87 363.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.88,
    y: 74.93,
    width: 124.41,
    height: 394.29,
    transform: "translate(1046.17 544.14) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.88,
    y: 74.93,
    width: 62.21,
    height: 393.2,
    transform: "translate(983.97 543.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.15,
    y: 36.22,
    width: 43.93,
    height: 38.71,
    transform: "translate(1098.24 111.14) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.15,
    y: 36.22,
    width: 10.47,
    height: 38.71,
    transform: "translate(1064.78 111.14) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "595.66 74.93 595.66 72.67 457.24 72.67 457.24 74.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 91.81,
    width: 10.53,
    height: 22.2,
    transform: "translate(1110.94 205.82) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,122.73c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,122.49,523.09,122.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 91.81,
    width: 10.53,
    height: 22.2,
    transform: "translate(985.44 205.82) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,122.73c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S460.34,122.49,460.34,122.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 135.89,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 293.99) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,166.81c0,.24,13.93.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S460.34,166.58,460.34,166.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 181.31,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 384.83) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,212.23c0,.24,13.93.42,31.1.42s31.1-.18,31.1-.42-13.92-.42-31.1-.42S460.34,212,460.34,212.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 226.73,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 475.66) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,257.65c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S460.34,257.41,460.34,257.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 270.84,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 563.89) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,301.76c0,.24,13.93.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S460.34,301.53,460.34,301.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 315.14,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 652.49) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.46,
    y: 360.02,
    width: 10.53,
    height: 22.21,
    transform: "translate(985.44 742.24) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,346.06c0,.23,13.93.42,31.1.42s31.1-.19,31.1-.42-13.92-.42-31.1-.42S460.34,345.83,460.34,346.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 136.57,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 295.34) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,167.49c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,167.25,523.09,167.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 181.33,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 384.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,212.25c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,212,523.09,212.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 226.09,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 474.38) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,257c0,.23,13.92.42,31.1.42s31.1-.19,31.1-.42-13.92-.43-31.1-.43S523.09,256.77,523.09,257Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 270.84,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 563.89) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,301.76c0,.24,13.92.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S523.09,301.53,523.09,301.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 315.6,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 653.41) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09,346.52c0,.24,13.92.43,31.1.43s31.1-.19,31.1-.43-13.92-.42-31.1-.42S523.09,346.29,523.09,346.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.2,
    y: 360.36,
    width: 10.53,
    height: 22.21,
    transform: "translate(1110.94 742.93) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "542.43 469.21 686.21 469.21 686.84 241.98 543.06 241.98 542.43 469.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.06,
    y: 241.98,
    width: 71.89,
    height: 227.23,
    transform: "translate(1158.01 711.2) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.65,
    y: 197.25,
    width: 50.77,
    height: 44.73,
    transform: "translate(1290.07 439.23) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.65,
    y: 197.25,
    width: 12.1,
    height: 44.73,
    transform: "translate(1251.4 439.23) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.85,
    y: 239.37,
    width: 159.97,
    height: 2.61,
    transform: "translate(1237.67 481.35) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.29,
    y: 261.49,
    width: 12.17,
    height: 25.66,
    transform: "translate(1304.75 548.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,297.23c0,.27,16.09.48,35.94.48s36-.21,36-.48-16.09-.49-36-.49S615,297,615,297.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.77,
    y: 261.49,
    width: 12.17,
    height: 25.66,
    transform: "translate(1159.72 548.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.43,297.23c0,.27,16.1.48,36,.48s35.94-.21,35.94-.48-16.09-.49-35.94-.49S542.43,297,542.43,297.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.77,
    y: 312.44,
    width: 12.17,
    height: 25.66,
    transform: "translate(1159.72 650.54) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.43,348.17c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,347.9,542.43,348.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.77,
    y: 364.93,
    width: 12.17,
    height: 25.66,
    transform: "translate(1159.72 755.52) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.43,400.66c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,400.39,542.43,400.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.77,
    y: 417.41,
    width: 12.17,
    height: 25.66,
    transform: "translate(1159.72 860.49) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.43,453.15c0,.27,16.1.49,36,.49s35.94-.22,35.94-.49-16.09-.49-35.94-.49S542.43,452.88,542.43,453.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.29,
    y: 313.22,
    width: 12.17,
    height: 25.66,
    transform: "translate(1304.75 652.1) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,349c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,348.68,615,349Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.29,
    y: 364.95,
    width: 12.17,
    height: 25.66,
    transform: "translate(1304.75 755.55) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,400.68c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,400.41,615,400.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.29,
    y: 416.67,
    width: 12.17,
    height: 25.66,
    transform: "translate(1304.75 859.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,452.41c0,.27,16.09.49,35.94.49s36-.22,36-.49-16.09-.49-36-.49S615,452.14,615,452.41Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.34,412.66a10.62,10.62,0,0,1,5.5,6.24,18.56,18.56,0,0,1,.73,8.45c-.62,5.48-3.73,11-7.09,15.4-4.61-4-5.68-11.06-6-14.66-.5-5.69,2.06-16.28,6.85-15.43",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.85,451.8a9.06,9.06,0,0,1,2.93-8.62,12.05,12.05,0,0,1,8.88-2.78,5.11,5.11,0,0,1,3.9,1.75,3.91,3.91,0,0,1,.06,3.93,7.93,7.93,0,0,1-2.91,2.87c-4,2.51-8.34,4.2-12.86,2.85",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.93,468.61a5.72,5.72,0,0,1,.16-1.13c.15-.79.34-1.81.56-3a32,32,0,0,1,3.14-9.73,19.56,19.56,0,0,1,7-7.42,13.59,13.59,0,0,1,2.84-1.26c.35-.11.63-.16.82-.21a.92.92,0,0,1,.29,0,21.54,21.54,0,0,0-3.81,1.75,20.13,20.13,0,0,0-6.78,7.37,34.58,34.58,0,0,0-3.21,9.59c-.28,1.28-.51,2.31-.68,3A6.26,6.26,0,0,1,590.93,468.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.1,420.89a1.61,1.61,0,0,1,.06.49c0,.37.05.84.08,1.42.07,1.23.14,3,.21,5.2.14,4.39.26,10.47.23,17.17s-.2,12.78-.38,17.18c-.09,2.19-.17,4-.25,5.2,0,.57-.07,1-.1,1.41a1.61,1.61,0,0,1-.06.49,2.73,2.73,0,0,1,0-.5c0-.36,0-.83,0-1.41,0-1.28.08-3,.13-5.2.11-4.4.23-10.46.26-17.17s0-12.77-.11-17.16c0-2.16-.06-3.93-.08-5.21,0-.58,0-1.05,0-1.41A2.73,2.73,0,0,1,591.1,420.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.86,455.13a21.2,21.2,0,0,0-11.58-15.53c-1.54-.74-3.55-1.22-4.82-.07s-1,3.21-.37,4.8a18.1,18.1,0,0,0,16.66,11.25",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,444.8a6.13,6.13,0,0,1,1,.43,9.62,9.62,0,0,1,1.11.59c.41.26.91.51,1.41.88s1.06.74,1.61,1.22a21.47,21.47,0,0,1,1.72,1.55,24.61,24.61,0,0,1,3.26,4.19,22.91,22.91,0,0,1,2.14,4.86,20,20,0,0,1,.55,2.26,17.59,17.59,0,0,1,.27,2,14.32,14.32,0,0,1,.08,1.66,9.45,9.45,0,0,1,0,1.25,6.78,6.78,0,0,1-.11,1.06c-.1,0,.06-1.52-.21-3.94a17.83,17.83,0,0,0-.32-2,19,19,0,0,0-.57-2.21,23.83,23.83,0,0,0-2.14-4.76,24.28,24.28,0,0,0-3.18-4.14c-.57-.57-1.11-1.11-1.66-1.56a19.21,19.21,0,0,0-1.57-1.24C579.38,445.51,578,444.88,578,444.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.72,243.15l-39.66-3.94-6.49,7.24s39.71,13.63,41.84,13.53,8.33-9.24,8.33-9.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.72,443.31l1.36,17.18s-16.94,6.78-17,10l33.33-1.06-1-26.86Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.12,458.67a1.38,1.38,0,0,1,1,1.53,1.31,1.31,0,0,1-1.5,1,1.44,1.44,0,0,1-1.07-1.62,1.36,1.36,0,0,1,1.68-.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.41,469.41l-.08-2.14L444,469a2.53,2.53,0,0,0-1.08,1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.78,460.61c0,.17.83.21,1.66.7s1.3,1.17,1.44,1.09-.13-1-1.15-1.59S459.73,460.46,459.78,460.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.31,462.22c0,.16.69.41,1.28,1.08s.78,1.4.94,1.39.23-.95-.51-1.77S456.31,462.07,456.31,462.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.49,466.53c.15,0,.34-.8-.12-1.68s-1.24-1.21-1.31-1.07.43.6.8,1.33S454.32,466.52,454.49,466.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.9,456.63c.08.15.82-.11,1.75-.08s1.67.28,1.75.14-.64-.7-1.74-.72S459.82,456.51,459.9,456.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.15,453a3.14,3.14,0,0,0,1.68-.08,7.59,7.59,0,0,0,1.74-.61,8.7,8.7,0,0,0,.95-.56,2,2,0,0,0,.49-.42.72.72,0,0,0,0-.87.92.92,0,0,0-.74-.35,2.22,2.22,0,0,0-.63.11,6.32,6.32,0,0,0-1,.41,5.77,5.77,0,0,0-1.51,1.09c-.75.75-1,1.38-.93,1.41s.43-.48,1.2-1.11a6.52,6.52,0,0,1,1.47-.92,6.23,6.23,0,0,1,.95-.33c.36-.11.66-.13.76,0s0,.08,0,.19a1.9,1.9,0,0,1-.36.3,8.76,8.76,0,0,1-2.48,1.24A11.08,11.08,0,0,0,459.15,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.81,443.31l1.35,17.18s-16.94,6.78-17,10l33.34-1.06-1-26.86Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.21,458.67a1.37,1.37,0,0,1,1,1.53,1.31,1.31,0,0,1-1.5,1,1.45,1.45,0,0,1-1.07-1.62,1.37,1.37,0,0,1,1.68-.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.5,469.41l-.08-2.14L486.08,469a2.57,2.57,0,0,0-1.08,1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.86,460.61c0,.17.84.21,1.67.7s1.29,1.17,1.44,1.09-.14-1-1.16-1.59S501.82,460.46,501.86,460.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.39,462.22c0,.16.69.41,1.28,1.08s.78,1.4.95,1.39.22-.95-.52-1.77S498.39,462.07,498.39,462.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.57,466.53c.15,0,.34-.8-.12-1.68s-1.24-1.21-1.31-1.07.44.6.8,1.33S496.4,466.52,496.57,466.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,456.63c.07.15.81-.11,1.75-.08s1.66.28,1.74.14-.64-.7-1.74-.72S501.9,456.51,502,456.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.23,453a3.14,3.14,0,0,0,1.68-.08,7.28,7.28,0,0,0,1.74-.61,7.85,7.85,0,0,0,1-.56,2,2,0,0,0,.49-.42.7.7,0,0,0,0-.87.89.89,0,0,0-.74-.35,2.29,2.29,0,0,0-.63.11,6.32,6.32,0,0,0-1,.41,5.94,5.94,0,0,0-1.51,1.09c-.75.75-1,1.38-.93,1.41s.43-.48,1.2-1.11a6.75,6.75,0,0,1,1.47-.92,7.09,7.09,0,0,1,1-.33c.36-.11.66-.13.76,0s0,.08,0,.19a1.43,1.43,0,0,1-.36.3,8.36,8.36,0,0,1-.87.55,9.76,9.76,0,0,1-1.6.69A11,11,0,0,0,501.23,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.11,294.36c-1.57,2-33.32,76-33.32,83.49s11.87,76.91,11.87,76.91l21.8-.75s1.61-37.36-.35-48.33S472.72,380,472.72,380l31.22-55.07s3.52-21.17,0-27.44S476.11,294.36,476.11,294.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.15,351.59c0,.78,11.34,32.49,13.19,42.29s10.18,61.7,10.18,61.7l21.7-1.57s-2-55-5.48-69.89-6.28-27.44-6.28-36.06,2.68-8.64,1.54-21-14.08-16.25-14.08-16.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.67,347.12a6.38,6.38,0,0,1-.4,1.4c-.28.9-.74,2.18-1.35,3.74a114.06,114.06,0,0,1-12.27,23.13c-1,1.38-1.76,2.48-2.34,3.22a6.35,6.35,0,0,1-.94,1.11,7.56,7.56,0,0,1,.76-1.24l2.18-3.31c1.83-2.81,4.24-6.75,6.64-11.26s4.3-8.72,5.6-11.8c.6-1.47,1.11-2.69,1.52-3.66A7.8,7.8,0,0,1,489.67,347.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.59,175.42a7.73,7.73,0,0,1-2.13-8,1,1,0,0,0-.48-1.53,5.76,5.76,0,0,1-2.46-3.77,4.46,4.46,0,0,1,1.59-4.13c-2.15-1-2.78-4.14-1.5-6.16a6,6,0,0,1,6.28-2.33,3.4,3.4,0,0,1,.93-3.94,6.7,6.7,0,0,1,4-1.46c1.94-.15,4.21.31,5.13,2a3,3,0,0,1,2.69-2,6.53,6.53,0,0,1,7.06,5.12,5.93,5.93,0,0,1,3.48-1,2.8,2.8,0,0,1,2.58,2.23,3.56,3.56,0,0,1,3.2-1.34,4.32,4.32,0,0,1,2.49.67,2.15,2.15,0,0,1,.9,2.29,3.42,3.42,0,0,1,2.29,6.41,4.37,4.37,0,0,1-.47,7.41,1.2,1.2,0,0,1,.59,1.78,2.34,2.34,0,0,1-1.92.9c0,2.55.05,5.09.08,7.63a15.35,15.35,0,0,1-.47,4.88,5.22,5.22,0,0,1-3.14,3.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.57,168.07c.26-6.15,6.73-12.43,12.85-11.92l19.86,3.37v3.31l.25,42.71-23.08,10.2.32-16s-7.85-1.14-9.67-11.35C474.19,183.28,474.27,174.91,474.57,168.07Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.93,175.08a1.31,1.31,0,0,0,1.29,1.3,1.25,1.25,0,0,0,1.32-1.21,1.3,1.3,0,0,0-1.28-1.3A1.25,1.25,0,0,0,476.93,175.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.46,172.38c.16.17,1.14-.59,2.55-.61s2.45.66,2.6.48-.09-.38-.55-.7A3.58,3.58,0,0,0,479,171a3.44,3.44,0,0,0-2,.7C476.52,172,476.38,172.31,476.46,172.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.62,175.55a1.31,1.31,0,0,0,1.29,1.3,1.26,1.26,0,0,0,1.33-1.21,1.31,1.31,0,0,0-1.29-1.3A1.26,1.26,0,0,0,489.62,175.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.28,172.66c.16.17,1.14-.59,2.55-.62s2.45.66,2.6.49-.09-.39-.55-.71a3.58,3.58,0,0,0-2.09-.6,3.51,3.51,0,0,0-2,.71C490.34,172.27,490.2,172.58,490.28,172.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.41,183a9.56,9.56,0,0,0-2.3-.36c-.36,0-.7-.1-.77-.34a1.92,1.92,0,0,1,.22-1.08c.32-.88.66-1.8,1-2.77,1.4-4,2.4-7.19,2.24-7.25a48.49,48.49,0,0,0-2.81,7L482,181a2.1,2.1,0,0,0-.16,1.42.92.92,0,0,0,.61.52,2.85,2.85,0,0,0,.61.07A8.88,8.88,0,0,0,485.41,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.77,199.71a25.88,25.88,0,0,0,13.59-4s-3.41,7.29-13.64,6.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.07,186.35a2.56,2.56,0,0,1,2.26-1,2.33,2.33,0,0,1,1.61.83,1.47,1.47,0,0,1,.15,1.69,1.7,1.7,0,0,1-1.84.5,5.28,5.28,0,0,1-1.82-1,1.6,1.6,0,0,1-.41-.41.47.47,0,0,1,0-.52",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.57,183.84c-.23,0-.2,1.53-1.49,2.65s-2.91,1-2.92,1.2.37.29,1.06.29a3.82,3.82,0,0,0,2.44-.91,3.39,3.39,0,0,0,1.15-2.22C489.85,184.21,489.68,183.83,489.57,183.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.75,167.61c.15.39,1.55.17,3.21.34s3,.59,3.21.24c.09-.17-.14-.53-.69-.89a5.34,5.34,0,0,0-2.4-.78,5.26,5.26,0,0,0-2.49.35C490,167.12,489.69,167.43,489.75,167.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.89,168.28c.26.31,1.22,0,2.39-.08s2.16.17,2.38-.17c.09-.17-.07-.48-.51-.78a3.41,3.41,0,0,0-3.83.2C476.91,167.79,476.78,168.12,476.89,168.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.54,156.17a5,5,0,0,0,7,5.94,1.94,1.94,0,0,0,.11,2.56,3.63,3.63,0,0,0,2.55,1,6.86,6.86,0,0,0,5.29-2.22,5,5,0,0,0,7.2,3.77,4.78,4.78,0,0,0-.91,5.29,4.7,4.7,0,0,0,4.68,2.58,4.75,4.75,0,0,0,4-3.6,5.18,5.18,0,0,0,1.86-8,3.1,3.1,0,0,0,1.92-2.42,6.21,6.21,0,0,0-.39-3.18,9.86,9.86,0,0,0-5-5.86,6.61,6.61,0,0,0-7.33,1.19,1.41,1.41,0,0,1-.71.52,1.28,1.28,0,0,1-1-.53c-1.27-1.29-2.59-2.68-4.34-3.12A4.84,4.84,0,0,0,488,152.7a5.65,5.65,0,0,0-6.2-2.64c-2.32.72-3.79,3.66-2.66,5.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.45,173.58a22.25,22.25,0,0,0,1.31,6.08c.31.83.79,1.75,1.65,1.92a1.88,1.88,0,0,0,1.93-1.13,5,5,0,0,0,.33-2.37,65.93,65.93,0,0,0-1.05-8.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.71,175.15c.13-.06,5.12-1.91,5.31,3.32s-5.08,4.34-5.09,4.19S505.71,175.15,505.71,175.15Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.44,180.62s.1.06.25.13a.93.93,0,0,0,.68,0,2.28,2.28,0,0,0,1-2.06,3.15,3.15,0,0,0-.3-1.3,1.07,1.07,0,0,0-.71-.67.46.46,0,0,0-.53.27c-.06.15,0,.25-.05.26s-.12-.08-.08-.3a.54.54,0,0,1,.19-.34.73.73,0,0,1,.5-.15,1.26,1.26,0,0,1,1,.78,3,3,0,0,1,.37,1.44,2.37,2.37,0,0,1-1.24,2.31,1,1,0,0,1-.84-.11C507.46,180.75,507.43,180.63,507.44,180.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.77,162.41l-.16.05-.48.08a7.1,7.1,0,0,1-1.84,0,4.73,4.73,0,0,1-1.29-.31,3.89,3.89,0,0,1-1.33-.85,3.75,3.75,0,0,1-.93-1.53,2.81,2.81,0,0,1,.12-2l.17.14a6.85,6.85,0,0,1-4.13,1.35,6.63,6.63,0,0,1-2.38-.44,4.32,4.32,0,0,1-1.11-.61,2.41,2.41,0,0,1-.77-1.06,3.4,3.4,0,0,1-.16-1.51,9.41,9.41,0,0,1,.27-1.44,4.53,4.53,0,0,1,.51-1.34,1.65,1.65,0,0,1,1.13-.84l.06.24a4.09,4.09,0,0,1-2.68,0,4.39,4.39,0,0,1-2-1.42,3.67,3.67,0,0,1-.81-2,4.37,4.37,0,0,1,.27-1.85,4.25,4.25,0,0,1,1.61-2.07,2.61,2.61,0,0,1,.85-.4,7,7,0,0,0-.8.47,4.27,4.27,0,0,0-1.74,3.84,3.57,3.57,0,0,0,.78,1.91,4.24,4.24,0,0,0,1.92,1.33,3.88,3.88,0,0,0,2.52,0l.06.25a1.4,1.4,0,0,0-.95.72,4.51,4.51,0,0,0-.48,1.27,5,5,0,0,0-.11,2.8,2.71,2.71,0,0,0,1.73,1.52,6.47,6.47,0,0,0,2.28.42,6.56,6.56,0,0,0,4-1.28l.38-.27-.21.42a2.64,2.64,0,0,0-.12,1.83,3.7,3.7,0,0,0,.87,1.46,3.55,3.55,0,0,0,1.25.83,4.88,4.88,0,0,0,1.24.33,8.17,8.17,0,0,0,1.83,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.64,160.46a1,1,0,0,1-.35.17,2.88,2.88,0,0,1-1.05.14,2.7,2.7,0,0,1-1.48-.54,1.32,1.32,0,0,1-.5-.86,1,1,0,0,1,.45-1l.11.24-.09,0a4.1,4.1,0,0,1-3.44-.5,3.55,3.55,0,0,1-.81-.72,1.21,1.21,0,0,1-.21-.33,8.43,8.43,0,0,0,1.12.89,4.09,4.09,0,0,0,3.26.41l.08,0L476,158l-1.13.61a.73.73,0,0,0-.32.72,1.06,1.06,0,0,0,.39.69,2.57,2.57,0,0,0,1.35.54A4.62,4.62,0,0,0,477.64,160.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.2,172.06s-.31-.23-.85-.52a5,5,0,0,0-2.25-.64,5.09,5.09,0,0,0-2.29.48c-.55.26-.85.5-.88.46a2.21,2.21,0,0,1,.8-.63,4.58,4.58,0,0,1,4.72.17A2.18,2.18,0,0,1,482.2,172.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,171.74a6.17,6.17,0,0,1-.69-.41,4.19,4.19,0,0,0-1.82-.5,4,4,0,0,0-1.84.37c-.45.2-.7.39-.73.35s.19-.26.64-.52a3.69,3.69,0,0,1,3.84.14C495.84,171.46,496,171.72,496,171.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.83,184.35s-.1-.09-.23-.21a1.51,1.51,0,0,0-.58-.35c-.53-.14-1-.14-1-.23a1.5,1.5,0,0,1,1.1,0,1.25,1.25,0,0,1,.65.48C490.86,184.2,490.86,184.34,490.83,184.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.83,185.09c-.07,0-.19-.38-.4-.82s-.43-.79-.38-.84.39.24.62.73S491.9,185.08,491.83,185.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,238.08c-.18,0-.74-7-.74-7s2.55.57,3,2.39.8,3.37.8,3.37l6.38,1.88,6.75-2.06L401,241.06s-3.65.5-3.93.49S387.65,238.08,387.65,238.08Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.32,246.67l-14.83-1.57s-11.15-6.92-12.41-7.78a1.1,1.1,0,0,1-.5-.78,1.4,1.4,0,0,1,1.9-1.44l13.11,4.75a2.88,2.88,0,0,0,2.38-.24l5.57-3.27s-2.25-2.18-3.67-3.86a2.65,2.65,0,0,1-.36-3.2c1.78.26,10.76,7,10.76,7l3.75,2.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.64,237l2.05-5.79a2,2,0,0,1,1.56,2.45c-.21,2.22-.18,4.1-.18,4.1l3,1.24-6.44-1.85",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.81,182.06a2.28,2.28,0,0,1,.86.59,5.4,5.4,0,0,1,1.51,2.39,4.83,4.83,0,0,1-.65,4.13,4.69,4.69,0,0,1-4.68,1.92,4.29,4.29,0,0,1-2.4-1.32,5.63,5.63,0,0,1-1.26-2.2,4.88,4.88,0,0,1,.53-4.15,4.35,4.35,0,0,1,2.27-1.69,2,2,0,0,1,1-.12s-.36.07-1,.31a4.3,4.3,0,0,0-2,1.7,4.58,4.58,0,0,0-.38,3.81,4.43,4.43,0,0,0,3.29,3.15,4.24,4.24,0,0,0,4.2-1.68,4.52,4.52,0,0,0,.69-3.76,5.72,5.72,0,0,0-1.31-2.35C511.09,182.31,510.79,182.09,510.81,182.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.44,202.31c5.09,5.7,9,18.43,10,26,1.07,8.5.71,10.7,1.36,17.67.67,7.24.93,56.47-1.81,60.28s-4.91,4.36-4.91,4.36-.36,3.82-.73,11.63S498.8,350.4,498.8,350.4s-2.36,3.45-7.26-2.18c-3.59-4.11-9.5-18-12.42-25.22a36.75,36.75,0,0,0-4.72-8.32h0a2.53,2.53,0,0,0-4,0L462.63,325s-4.14-2.56-4.5-5.29,2.18-10.17,4.54-18.52,6.1-37,6.1-37-.11-28.61,0-29c1-3.71,6.69-11,10.5-17.38a52.16,52.16,0,0,0,5.37-12.57l22.8-2.86Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.47,261.7c8.22.39,23.75-6.94,25.37-8.1,4.31-3.11,9.59-10.06,9.16-16.52a36.82,36.82,0,0,1-16.14,16.08,41.92,41.92,0,0,1-6.63,3.24"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M467,236.72A93.74,93.74,0,0,0,482.4,219c3.4-5.24,10.05-3.65,18.76,1.25,3.27,1.84,3.83,5.77,3.26,10A27,27,0,0,1,491,249.71c-10.48,6-27.07,14.39-29.9,15.64-2.3,1-7.4,1.13-11.74-1.33l1.45-26.14s8.76-2.57,12.24-.8l1.4.89,2.62-1.25",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,215.44s-.44-.51-1.39-1.22a10.3,10.3,0,0,0-4.59-1.8,11.83,11.83,0,0,0-7.14,1.21,21.76,21.76,0,0,0-6.82,5.88c-1,1.26-1.89,2.58-2.78,3.84s-1.82,2.44-2.74,3.52a64.56,64.56,0,0,1-5.23,5.42c-1.57,1.46-2.9,2.57-3.83,3.32-.46.38-.83.66-1.08.85s-.39.28-.41.26a14.76,14.76,0,0,1,1.35-1.28c.88-.8,2.17-2,3.7-3.44s3.29-3.31,5.1-5.47c.9-1.08,1.81-2.24,2.68-3.5s1.77-2.59,2.79-3.88a24.92,24.92,0,0,1,3.32-3.47,17.07,17.07,0,0,1,3.72-2.52,12.08,12.08,0,0,1,7.43-1.14,10,10,0,0,1,4.67,2,6.81,6.81,0,0,1,1,1A1.79,1.79,0,0,1,503,215.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.64,257.88a13.85,13.85,0,0,1,1.78-.86c1.15-.52,2.82-1.27,4.85-2.27s4.42-2.25,7-3.79a27.32,27.32,0,0,0,7.29-6.26,43.66,43.66,0,0,0,3-4,34.79,34.79,0,0,0,2.4-4,28.84,28.84,0,0,0,2.54-7.45,19.24,19.24,0,0,0,.32-5.3c-.12-1.25-.33-1.92-.27-1.94a1.5,1.5,0,0,1,.17.48,10.54,10.54,0,0,1,.32,1.44,17.9,17.9,0,0,1-.14,5.39,28.09,28.09,0,0,1-2.47,7.62A35.27,35.27,0,0,1,501,241a46.19,46.19,0,0,1-3,4.08,27.34,27.34,0,0,1-7.46,6.35c-2.59,1.51-5,2.74-7.07,3.7s-3.77,1.65-4.95,2.11c-.59.23-1.05.4-1.37.51A2.37,2.37,0,0,1,476.64,257.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.21,339.13a5.74,5.74,0,0,1,.17-.92c.12-.6.37-1.47.57-2.62a64.06,64.06,0,0,0,1.08-9.77c.18-4.15-.06-9.1-.29-14.61a99,99,0,0,1,.55-17.93,170.88,170.88,0,0,1,3.78-17.53,110.62,110.62,0,0,0,2.82-14.32,49.07,49.07,0,0,0,.2-9.81c-.06-1.16-.25-2.05-.3-2.66a5.4,5.4,0,0,1-.09-.93,5.09,5.09,0,0,1,.2.91c.09.61.32,1.49.41,2.66a45.85,45.85,0,0,1,0,9.87,104,104,0,0,1-2.71,14.4c-1.28,5.36-2.86,11.21-3.73,17.49a101.84,101.84,0,0,0-.59,17.84c.21,5.49.41,10.47.17,14.64a58.29,58.29,0,0,1-1.26,9.8c-.24,1.14-.52,2-.67,2.6A5.11,5.11,0,0,1,486.21,339.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.47,254.93a12,12,0,0,1,0-2.49c0-1.53.1-3.65.11-6s0-4.45-.05-6a13.85,13.85,0,0,1,0-2.49,10.73,10.73,0,0,1,.33,2.47c.13,1.54.22,3.67.21,6s-.13,4.48-.27,6A10.47,10.47,0,0,1,464.47,254.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.25,252.24a20.76,20.76,0,0,1-3.33-3.21,20.11,20.11,0,0,1-2.95-3.56,21.18,21.18,0,0,1,3.33,3.21A20.25,20.25,0,0,1,476.25,252.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.7,242a10.54,10.54,0,0,1,0-3.28,10.69,10.69,0,0,1,.51-3.24,10.18,10.18,0,0,1,0,3.28A10.69,10.69,0,0,1,477.7,242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.67,243.77a12,12,0,0,1-1-3.46,12.47,12.47,0,0,1-.5-3.56,12.65,12.65,0,0,1,1,3.45A13,13,0,0,1,486.67,243.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.75,223.48a9.52,9.52,0,0,1-3.13.39,9.31,9.31,0,0,1-3.14-.14,19.4,19.4,0,0,1,6.27-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.27,237a45.86,45.86,0,0,1,2-9.54,22.65,22.65,0,0,1-.75,4.82A23.12,23.12,0,0,1,495.27,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.53,222.43a9.26,9.26,0,0,1-2.87-1.14,9.53,9.53,0,0,1-2.65-1.62,9.66,9.66,0,0,1,2.88,1.15A9.23,9.23,0,0,1,501.53,222.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.77,245.88a15,15,0,0,1,3-2.54,15.31,15.31,0,0,1,3.33-2.13,15.21,15.21,0,0,1-3,2.55A15.48,15.48,0,0,1,453.77,245.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.15,252a9.81,9.81,0,0,1-3-1,9.61,9.61,0,0,1-2.78-1.5,9.92,9.92,0,0,1,3,1A9.74,9.74,0,0,1,460.15,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.88,260.56c.11.08-.33.87-1.21,1.52s-1.75.87-1.8.74.68-.54,1.49-1.15S456.76,260.47,456.88,260.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.35,214.87a12.15,12.15,0,0,1-2.58-2.45,12.46,12.46,0,0,1-2.2-2.81,24.2,24.2,0,0,1,4.78,5.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.55,227.94a7.11,7.11,0,0,1-1.56,2.17c-1,1.11-1.85,1.93-2,1.83a7.49,7.49,0,0,1,1.57-2.17C511.57,228.66,512.44,227.84,512.55,227.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.05,251a21.66,21.66,0,0,1-1.44-2.43,21,21,0,0,1-1.57-2.34,5,5,0,0,1,2,2.07A4.93,4.93,0,0,1,506.05,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.82,242.75a18.52,18.52,0,0,1-1.75,6,9.46,9.46,0,0,1,.63-3.08A10,10,0,0,1,513.82,242.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.55,267.84a10.32,10.32,0,0,1-1.69-2.73,10.07,10.07,0,0,1-1.22-3,19.32,19.32,0,0,1,2.91,5.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.08,263.34a9.16,9.16,0,0,1-3.05-.12,9,9,0,0,1-3-.64,9.09,9.09,0,0,1,3,.12A8.94,8.94,0,0,1,515.08,263.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.91,283.07a66.13,66.13,0,0,1,2.93-5.93,8.19,8.19,0,0,1-1.07,3.16A8,8,0,0,1,498.91,283.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.74,285.19a16.4,16.4,0,0,1-2.34-3.38,16.12,16.12,0,0,1-1.89-3.66,16.66,16.66,0,0,1,2.34,3.39A17,17,0,0,1,511.74,285.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.35,302a23.55,23.55,0,0,1,.11-5,24.06,24.06,0,0,1,.64-5,24.85,24.85,0,0,1-.12,5A25.35,25.35,0,0,1,502.35,302Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.57,309a18.54,18.54,0,0,1-1.83-6,9.56,9.56,0,0,1,1.16,2.93A9.8,9.8,0,0,1,494.57,309Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,323.28a12,12,0,0,1-2.62,2.31,11.53,11.53,0,0,1-2.94,1.9,12,12,0,0,1,2.62-2.31A12.24,12.24,0,0,1,500,323.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.3,318.26a16.89,16.89,0,0,1-.39-4.13,16.19,16.19,0,0,1,.14-4.15,17.2,17.2,0,0,1,.38,4.13A17,17,0,0,1,506.3,318.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.62,334.17c.09.11-.52.75-1.36,1.43s-1.61,1.13-1.7,1,.53-.75,1.37-1.43S502.53,334.06,502.62,334.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.17,301.47a13.42,13.42,0,0,1,.34-3.69,13.56,13.56,0,0,1,.85-3.6,13.4,13.4,0,0,1-.34,3.69A13.56,13.56,0,0,1,513.17,301.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.19,273.13a11,11,0,0,1-1.95-2.64,10.49,10.49,0,0,1-1.51-2.91,10.26,10.26,0,0,1,1.95,2.63A10.47,10.47,0,0,1,484.19,273.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,262.32c.08.12-.64.77-1.61,1.47s-1.82,1.15-1.91,1,.64-.78,1.61-1.47S490.91,262.2,491,262.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.27,269.87a8.57,8.57,0,0,1,.46-3,8.89,8.89,0,0,1,1-2.83,8.55,8.55,0,0,1-.46,2.95A8.85,8.85,0,0,1,472.27,269.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.86,288.21a15.72,15.72,0,0,1-2.23-3.39,16.32,16.32,0,0,1-1.77-3.64,15.41,15.41,0,0,1,2.23,3.39A16.32,16.32,0,0,1,477.86,288.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.22,294.18c.1.11-.78,1-2,2.07a8,8,0,0,1-2.3,1.69c-.1-.11.78-1,2-2.08A8,8,0,0,1,484.22,294.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.93,298.69c-.16,0,.05-1.7,0-3.76s-.37-3.73-.23-3.76a8.23,8.23,0,0,1,.75,3.74A8.37,8.37,0,0,1,469.93,298.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.16,309.73c.09.12-.86.94-2.1,1.84a7.7,7.7,0,0,1-2.41,1.42c-.09-.11.86-.94,2.1-1.84A7.7,7.7,0,0,1,466.16,309.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.21,314.25a6.77,6.77,0,0,1,0-2.66,7,7,0,0,1,.51-2.61,7,7,0,0,1,0,2.66A7.12,7.12,0,0,1,478.21,314.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.24,327.79a10.83,10.83,0,0,1-.84-4.1,10.63,10.63,0,0,1,.29-4.18,41.42,41.42,0,0,1,.23,4.14C484.06,325.93,484.38,327.76,484.24,327.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.24,259.56a14.78,14.78,0,0,1,0-5.52,14.78,14.78,0,0,1,0,5.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.94,211.87a9.35,9.35,0,0,1-1.67,2.54,9,9,0,0,1-2.09,2.23,9.21,9.21,0,0,1,1.68-2.55A8.66,8.66,0,0,1,484.94,211.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.76,209.93a31,31,0,0,1-7.78-1.74,15.16,15.16,0,0,1,3.95.62A15.52,15.52,0,0,1,497.76,209.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.53,204.84c.06.13-.73.62-1.77,1.1s-1.94.77-2,.64.74-.63,1.78-1.11S506.47,204.71,506.53,204.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M464.79,239.89c-.34,6.11-.41,13.26-.75,19.36a.62.62,0,0,0,.13.52c.21.18.53,0,.74-.14,2.12-1.74,2.67-4.75,2.68-7.49a28.27,28.27,0,0,0-2.8-12.25"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.29,204.5a3.73,3.73,0,1,0-4.73,3.45l0,1,1,.77-1.07.59-.05,1.3,1,.77-1.07.59,0,1.12.62.46-.65.37,0,.65.77.88,1.54-.92.29-7.72A3.73,3.73,0,0,0,345.29,204.5Zm-3.62-2.86a1.07,1.07,0,1,1-1.11,1A1.05,1.05,0,0,1,341.67,201.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,204.5a3.73,3.73,0,1,0-4.73,3.45l0,1,1,.77-1.07.59-.05,1.3,1,.77-1.07.59,0,1.12.62.46-.65.37,0,.65.77.88,1.54-.92.29-7.72A3.73,3.73,0,0,0,345.29,204.5Zm-3.62-2.86a1.07,1.07,0,1,1-1.11,1A1.05,1.05,0,0,1,341.67,201.64Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.67,201.64s-.1,0-.26,0a1.07,1.07,0,0,0-.58.37,1,1,0,1,0,1.09-.35c-.16,0-.26,0-.25-.06h.06l.2,0a1.1,1.1,0,0,1,.6.41,1.14,1.14,0,0,1,.13,1.05,1.13,1.13,0,0,1-.41.51,1.1,1.1,0,0,1-.67.19,1.15,1.15,0,0,1-.65-.24,1.11,1.11,0,0,1-.16-1.57,1.06,1.06,0,0,1,.63-.37.72.72,0,0,1,.2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.29,204.5v.29a4.61,4.61,0,0,1-.19.84,4.06,4.06,0,0,1-.69,1.19,3.78,3.78,0,0,1-1.51,1.06l0,0c-.07,2-.17,4.65-.28,7.72v0h0l-1.54.92,0,0,0,0-.77-.87v0h0c0-.21,0-.43,0-.65v0h0l.65-.36v.07l-.62-.47h0v0c0-.35,0-.73,0-1.12v0l0,0,1.07-.59v.07l-1-.76,0,0v-.36c0-.32,0-.64,0-1v0l0,0,1.07-.59v.07l-1-.76,0,0v0c0-.35,0-.7,0-1l0,.05a3.8,3.8,0,0,1-2.11-1.52,3.83,3.83,0,0,1-.39-.75,3.76,3.76,0,1,1,7.09-2.48l0,.14,0,.14c0,.09,0,.17.05.25s0,.29,0,.39v0c0-.1,0-.23,0-.39l-.06-.25,0-.13,0-.14a3.72,3.72,0,0,0-.72-1.3,3.79,3.79,0,0,0-1.63-1.1,3.69,3.69,0,0,0-4.63,4.84,3.67,3.67,0,0,0,.39.73,3.33,3.33,0,0,0,.55.64,3.71,3.71,0,0,0,1.5.84h0v0c0,.34,0,.68,0,1l0,0,1,.77.06,0-.07,0-1.06.59,0,0c0,.32,0,.64,0,1,0,.12,0,.23,0,.34l0,0,1,.77.06,0-.07,0-1.06.59,0,0c0,.39,0,.77,0,1.12l0,0,.62.47,0,0-.06,0-.65.37,0,0,0,.65v0l.77.88H341l1.54-.92,0,0c.12-3.08.22-5.73.3-7.72v0h0a3.72,3.72,0,0,0,2.19-2.21,4,4,0,0,0,.2-.83c0-.09,0-.16,0-.22A.32.32,0,0,0,345.29,204.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9,204.29a3.73,3.73,0,1,0-4.72,3.45h0l0,1,1,.76-1.06.6,0,1.3,1,.76-1.06.6-.05,1.12.62.46-.65.37,0,.65.77.87,1.54-.91.29-7.72A3.73,3.73,0,0,0,344.9,204.29Zm-3.62-2.87a1.07,1.07,0,1,1-1.11,1A1.08,1.08,0,0,1,341.28,201.42Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9,204.29a3.73,3.73,0,1,0-4.72,3.45h0l0,1,1,.76-1.06.6,0,1.3,1,.76-1.06.6-.05,1.12.62.46-.65.37,0,.65.77.87,1.54-.91.29-7.72A3.73,3.73,0,0,0,344.9,204.29Zm-3.62-2.87a1.07,1.07,0,1,1-1.11,1A1.08,1.08,0,0,1,341.28,201.42Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.28,201.42s-.1,0-.26.05a1,1,0,0,0-.58.37,1,1,0,1,0,1.75,1,1.05,1.05,0,0,0-.66-1.4c-.16,0-.25,0-.25-.06h.07l.19,0a1,1,0,0,1,.6.41,1.09,1.09,0,0,1,.13,1,1.13,1.13,0,0,1-.41.51,1.07,1.07,0,0,1-.66.19,1.11,1.11,0,0,1-.81-1.82,1,1,0,0,1,.62-.36.47.47,0,0,1,.2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9,204.29v.29a4,4,0,0,1-.19.84,3.7,3.7,0,0,1-.69,1.18,3.83,3.83,0,0,1-1.51,1.07l0,0c-.07,2-.16,4.64-.27,7.72v0h0l-1.54.92,0,0,0,0-.78-.87v0c0-.2,0-.42,0-.65v0h0l.65-.37v.08l-.62-.47h0v0c0-.35,0-.73,0-1.11v0h0l1.07-.6v.08l-1-.76,0,0v-.37c0-.32,0-.64,0-1v0h0l1.07-.6v.08l-1-.76,0,0v0c0-.35,0-.7,0-1l0,0a3.86,3.86,0,0,1-1.54-.87,3.16,3.16,0,0,1-.56-.65,3.87,3.87,0,0,1-.4-.75,3.77,3.77,0,0,1,2.31-4.93,3.71,3.71,0,0,1,2.42,0,3.75,3.75,0,0,1,1.64,1.13,3.6,3.6,0,0,1,.72,1.31l0,.15,0,.14c0,.09,0,.17.05.25a3.22,3.22,0,0,1,0,.39v.25a.28.28,0,0,1,0,.08V204c0-.1,0-.23,0-.39s0-.16-.05-.25l0-.13,0-.15a3.69,3.69,0,0,0-.72-1.29,3.65,3.65,0,0,0-1.63-1.1,3.7,3.7,0,0,0-4.63,4.84,3.82,3.82,0,0,0,.94,1.37,3.8,3.8,0,0,0,1.51.84h0v0c0,.35,0,.69,0,1l0,0,1,.77.06,0-.06,0-1.07.6,0,0,0,1,0,.34,0,0,1,.77.06,0-.06,0-1.07.6,0,0c0,.39,0,.77,0,1.12l0,0,.62.47.06,0-.06,0-.66.37,0,0,0,.65v0l.77.87h-.05l1.54-.92,0,0c.12-3.07.23-5.72.3-7.71v0h0a3.7,3.7,0,0,0,1.5-1,3.75,3.75,0,0,0,.89-2l0-.22A.42.42,0,0,0,344.9,204.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,204.32a7.4,7.4,0,0,0-.09-.8,3.08,3.08,0,0,0-.34-.88,3.25,3.25,0,0,0-.79-.95,3.26,3.26,0,0,0-3.05-.57,3,3,0,0,0-.84.41,2.63,2.63,0,0,0-.38.3,3.81,3.81,0,0,0-.33.36,3.21,3.21,0,0,0-.14,3.82,2.37,2.37,0,0,0,.3.39c.12.12.23.23.35.33a3,3,0,0,0,.81.47,3.23,3.23,0,0,0,1.69.21,3.33,3.33,0,0,0,1.39-.55,3.46,3.46,0,0,0,.87-.89,3.19,3.19,0,0,0,.4-.85,6.65,6.65,0,0,0,.15-.8v.21c0,.07,0,.16,0,.26a3.21,3.21,0,0,1-.08.34,3,3,0,0,1-.39.87,3.22,3.22,0,0,1-.87.91,3.13,3.13,0,0,1-1.42.57,3.32,3.32,0,0,1-1.74-.2,3.09,3.09,0,0,1-.82-.48,3.92,3.92,0,0,1-.37-.34,4.08,4.08,0,0,1-.31-.39,3.35,3.35,0,0,1-.57-2,3.32,3.32,0,0,1,.72-1.94,3.92,3.92,0,0,1,.34-.37,3.79,3.79,0,0,1,.39-.31,3.61,3.61,0,0,1,.86-.42,3.38,3.38,0,0,1,1.75-.07,3.27,3.27,0,0,1,1.37.68,3.39,3.39,0,0,1,.8,1,3.12,3.12,0,0,1,.32.89,2.67,2.67,0,0,1,.05.35,2.36,2.36,0,0,1,0,.25v.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,202.55s0-.11,0-.3a1.27,1.27,0,0,0-.44-.69,1.23,1.23,0,0,0-.5-.24,1.27,1.27,0,0,0-.64,0,1.17,1.17,0,0,0-.58.41,1.22,1.22,0,0,0-.26.7,1.2,1.2,0,0,0,.21.72,1.23,1.23,0,0,0,.54.45,1.3,1.3,0,0,0,.64.08,1.21,1.21,0,0,0,.52-.21,1.18,1.18,0,0,0,.48-.65c.06-.19.06-.3.07-.3s0,0,0,.08a1.11,1.11,0,0,1,0,.23,1.25,1.25,0,0,1-.48.7,1.33,1.33,0,0,1-1.23.15,1.24,1.24,0,0,1-.59-.48,1.3,1.3,0,0,1,.06-1.53,1.3,1.3,0,0,1,.62-.43,1.22,1.22,0,0,1,.68,0,1.22,1.22,0,0,1,1,1,1.11,1.11,0,0,1,0,.23C342.49,202.53,342.49,202.55,342.48,202.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.73,215.53s0-1.76.11-3.92.16-3.93.19-3.93,0,1.76-.1,3.93S341.76,215.53,341.73,215.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.6,201.79a.5.5,0,0,1-.5,0v-4.73l.5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,201.87a.62.62,0,0,1-.26-.06h0V197l.54,0v4.73h0A.62.62,0,0,1,341.35,201.87Zm-.23-.09a.53.53,0,0,0,.46,0v-4.66l-.46,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,188.66l8.65,4.78a2.38,2.38,0,0,1-3.41,1.08c-2.5-1.11-7-3.85-7-3.85l-3.44,1.39-2.63-3.18Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.61,205.74a8.69,8.69,0,0,0,8.08-.77c3.94-2.69,4.23-3.58,5.85-4.07,1.18-.36,6.68-1.11,8.84-1.62a1.26,1.26,0,0,0,.52-2.2,13.47,13.47,0,0,0-3.73-.76,15.66,15.66,0,0,0-3.42.36c-2.2.41-4.87-1-4.87-1l.06-1.38,5.47-1a21.91,21.91,0,0,0,6,3.38,7.15,7.15,0,0,0,3.59-.47l0-.31-7.74-5.54-7.22-1.23-2.22-.37-18.64,11.13,4.84,8.58Z",
    style: {
      fill: "#bd8c83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,434.24l-3.7,19.8s18.88,10.41,18.56,14.13L237,462.38l4.5-31.08Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.76,434.24l-3.7,19.8s18.88,10.41,18.56,14.13L237,462.38l4.5-31.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M245.37,450.57a1.61,1.61,0,0,0-1.37,1.64,1.54,1.54,0,0,0,1.62,1.36,1.68,1.68,0,0,0,1.43-1.74,1.6,1.6,0,0,0-1.84-1.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,462.38l.58-3.12L274.38,466s1.61,1,1.24,2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.72,453.94c0,.18-1,.13-2,.6s-1.63,1.18-1.8,1.08.29-1.15,1.53-1.69S257.79,453.77,257.72,453.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.52,456.22c0,.19-.85.39-1.61,1.09s-1.07,1.52-1.26,1.48-.14-1.12.82-2S261.54,456,261.52,456.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,461.42c-.18,0-.3-1,.34-1.93s1.58-1.24,1.64-1.07-.58.64-1.09,1.43S263.29,461.43,263.1,461.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,449.33c-.1.16-.93-.23-2-.32s-2,.13-2-.05.83-.73,2.09-.61S258.18,449.2,258.06,449.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.15,439l-.36,20.13s20.35,7.13,20.64,10.86l-39.06.71-.74-31.4Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,457.64a1.6,1.6,0,0,0-1.07,1.84,1.53,1.53,0,0,0,1.81,1.08,1.69,1.69,0,0,0,1.13-2,1.61,1.61,0,0,0-2-.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,470.68l0-3.17,37.44.5s1.75.73,1.57,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,458.9c0,.19-1,.3-1.88.93s-1.42,1.44-1.59,1.37.08-1.18,1.22-1.92S248.46,458.73,248.42,458.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,460.52c0,.19-.78.53-1.41,1.35s-.8,1.67-1,1.67-.34-1.08.47-2.09S252.54,460.34,252.55,460.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,465.39c-.17,0-.45-.91,0-2s1.36-1.49,1.44-1.33-.46.73-.83,1.6S255.15,465.36,255,465.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,454.31c-.08.17-1-.08-2,0s-1.91.45-2,.28.7-.85,2-.95S248.08,454.15,248,454.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5,287.74a3.19,3.19,0,0,1-.08.92,13.54,13.54,0,0,1-.65,2.42,15.86,15.86,0,0,1-12.12,10.27,13,13,0,0,1-2.5.23,2.86,2.86,0,0,1-.91-.07c0-.08,1.31,0,3.35-.48A16.48,16.48,0,0,0,238.47,291C239.24,289,239.41,287.72,239.5,287.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59,282.63l.52,19.92L227,364.4s-1.88,30.13-3.07,47.14c-1,14.77,2,40.37,2,40.37l24.86-.65,6.66-85.81,4.14-53.51,8.39-28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,287.16,283.6,368a33.94,33.94,0,0,1-2,12.11l-21.36,59.51-1.06,3.92-14.94-3.2,7.25-157.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,301.45s0,.13,0,.39V303c0,1,0,2.5,0,4.38,0,3.81-.11,9.31-.29,16.11-.39,13.6-1.31,32.37-2.95,53s-3.5,39.36-4.88,52.88c-.71,6.74-1.28,12.19-1.68,16-.2,1.87-.36,3.33-.48,4.35-.05.47-.1.85-.13,1.13s-.06.38-.06.38a1.64,1.64,0,0,1,0-.39c0-.28.05-.65.09-1.13.09-1,.22-2.49.39-4.36.37-3.81.89-9.28,1.53-16,1.3-13.52,3.14-32.21,4.75-52.89s2.6-39.43,3.08-53c.23-6.8.39-12.3.44-16.1,0-1.88.08-3.35.1-4.38,0-.48,0-.86,0-1.14A1.93,1.93,0,0,1,261.2,301.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,290.91a1.28,1.28,0,1,1-1.31-1.25A1.29,1.29,0,0,1,262.5,290.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,300.47a8,8,0,0,1-1.79-1.6,19.49,19.49,0,0,1-3.26-4.81,19.8,19.8,0,0,1-1.71-5.55,8.18,8.18,0,0,1-.12-2.4c.08,0,.15.91.44,2.35a23.13,23.13,0,0,0,4.89,10.2C282.06,299.78,282.72,300.41,282.67,300.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,310.27c0-1-5.52-17-5.52-17l37.74-20.06,19.65,32.56-41.75,21.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.79,163.64c.35,1.16-.73,2.29-1.85,2.77s-2.42.65-3.34,1.45c-1.88,1.63-1.36,5.08-3.41,6.51-1,.69-2.33.68-3.44,1.16a5.51,5.51,0,0,0-2.89,5.06,16.13,16.13,0,0,0,1.47,5.94,3.53,3.53,0,0,0,1,1.64,3.58,3.58,0,0,0,2.72.36,132.45,132.45,0,0,0,14.62-2.86,2.26,2.26,0,0,0,1.49-.85,2.22,2.22,0,0,0,.17-1.2l-.42-9.74a19.2,19.2,0,0,0-.89-6,6.5,6.5,0,0,0-4.12-4.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77,161.07c-.85-.78-2.32.3-2.32,1.45a4.57,4.57,0,0,0,1.68,2.93l2.33,2.38a1.84,1.84,0,0,0,1.27.73c.92-.05,1.17-1.32,1-2.22a8.11,8.11,0,0,0-4.06-5.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.21,135.53c-.93-2.11-3.45-3.68-3.62-4.35-.45-1.76,1.08-3.66.51-5.38-1.33-4-4.63-3.51-4.63-3.51-1.5-1.82-3.53-4.23-6.83-5.08-3.58-.93-8.84-1.61-12,.26s-5.51,3.13-6.54,6.67l22.54,39.64c2.57-1.2,4.19-3.84,5.14-6.52s1.38-5.53,2.44-8.17c.79-2-.08-5.1,1.69-6.27C273.09,141.35,273.06,137.47,272.21,135.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.87,139.1a17.39,17.39,0,0,0-17.05-16.28h-.9c-9.71.4-14.79,8.87-14.12,18.56L232,173.21l7.12,4.78c5.55,4.16,17.05,7.11,17.05,3h0V171.9s9.35-1.29,9.63-10.61C265.88,156.79,265.4,147.5,264.87,139.1Z",
    style: {
      fill: "#bd8c83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79,146.82a1.34,1.34,0,0,1-1.31,1.32,1.27,1.27,0,0,1-1.35-1.22,1.34,1.34,0,0,1,1.3-1.33A1.28,1.28,0,0,1,262.79,146.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.93,144.11c-.17.17-1.16-.6-2.59-.62s-2.5.68-2.65.5.1-.39.56-.71a3.61,3.61,0,0,1,2.12-.62,3.5,3.5,0,0,1,2.07.71C262.87,143.71,263,144,262.93,144.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,146.82a1.34,1.34,0,0,1-1.31,1.32,1.27,1.27,0,0,1-1.35-1.22,1.34,1.34,0,0,1,1.3-1.33A1.29,1.29,0,0,1,249.1,146.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,144.32c-.16.17-1.18-.57-2.61-.55s-2.48.74-2.64.57.09-.39.55-.73a3.56,3.56,0,0,1,2.1-.67,3.52,3.52,0,0,1,2.08.65C249,143.92,249.14,144.24,249.06,144.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.71,154.36a9.7,9.7,0,0,1,2.34-.38c.36,0,.71-.1.78-.35a1.84,1.84,0,0,0-.23-1.08l-1-2.81c-1.44-4-2.47-7.27-2.31-7.33s1.46,3.14,2.89,7.13q.53,1.47,1,2.82a2.16,2.16,0,0,1,.17,1.44.94.94,0,0,1-.61.52,2.58,2.58,0,0,1-.63.08A9.56,9.56,0,0,1,253.71,154.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,139.28c-.19.37-1.58,0-3.27,0s-3.11.26-3.28-.12c-.08-.18.21-.51.8-.81a5.48,5.48,0,0,1,2.51-.52,5.36,5.36,0,0,1,2.48.63C248.88,138.76,249.15,139.1,249.06,139.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,139.32c-.29.32-1.4,0-2.75-.08s-2.48.18-2.74-.17c-.11-.16.08-.49.58-.79a4.25,4.25,0,0,1,2.24-.49,4.13,4.13,0,0,1,2.18.69C263,138.83,263.18,139.16,263.05,139.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,123.47a7.07,7.07,0,0,0,8.33,7c1.58-.29,3.31-1.09,4.67-.25s1.5,3.05,2.77,4.15c1.82,1.58,4.71.1,7,.78,1.78.53,2.9,2.24,4.08,3.67s3,2.8,4.74,2.27a21.21,21.21,0,0,0-.7-4.76,7,7,0,0,0-2.71-3.87c-.73-.49-1.59-.78-2.28-1.33-1.48-1.2-1.82-3.28-2.73-5a7.75,7.75,0,0,0-5.9-3.91c-2-.2-4.12.41-6.1-.09-1.46-.37-2.74-1.32-4.22-1.6-2.89-.55-5.57,1.52-7.66,3.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,127.58c-1.3-.37-3.94-1.21-4.64-2.33a7.88,7.88,0,0,0-6.88-4,6.52,6.52,0,0,0-5.87,5.16,9.37,9.37,0,0,0-8.07,5.19,10.88,10.88,0,0,0,.3,10.12,5.34,5.34,0,0,1,1,2.49c0,1.15-.83,2.06-1.43,3a9.75,9.75,0,0,0-.25,9c1.26,2.82,2.15,3.81,3.95,4.37,3.52,1.11,3.43,6,4.79,7.37l2.27-20.16a2.05,2.05,0,0,0,.55.2c3.47.78,3.92-6,3.15-7.93a20.41,20.41,0,0,0,3.48-3.65,14.58,14.58,0,0,0,1.59-7C244.24,129.5,249.57,127.74,249,127.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,148c-.16-.07-6.38-2-6.28,4.38s6.48,5,6.48,4.78S234.71,148,234.71,148Z",
    style: {
      fill: "#bd8c83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,154.72s-.11.08-.3.17a1.09,1.09,0,0,1-.83,0,2.78,2.78,0,0,1-1.31-2.45,3.7,3.7,0,0,1,.29-1.59,1.31,1.31,0,0,1,.83-.87.58.58,0,0,1,.66.3c.08.17,0,.3.08.31s.13-.11.08-.37a.71.71,0,0,0-.26-.39.79.79,0,0,0-.61-.16,1.55,1.55,0,0,0-1.15,1,3.69,3.69,0,0,0-.36,1.78,2.88,2.88,0,0,0,1.66,2.73,1.23,1.23,0,0,0,1-.18C232.92,154.88,233,154.73,232.93,154.72Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.12,171.9s-8.49-1.3-13.44-5.07c0,0,2.61,7.77,13.43,8Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,155.25c.23,0,.21,1.57,1.54,2.71s3,1,3,1.22-.38.3-1.09.31a3.91,3.91,0,0,1-2.52-.93,3.43,3.43,0,0,1-1.19-2.27C249.72,155.63,249.9,155.24,250,155.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9,173.21s-19.47,9.61-23.54,15.31c-4.94,6.91,8.74,29,9.78,34.48.5,2.63,3.76,22.41,2.23,38a266.54,266.54,0,0,0-1.17,31.21L282,287.16c0-11-2.84-19.42-4.72-33.33l-4.72-45.4-6.83-23.33L256.06,181Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.58 298.12 208.49 334 258.12 308.15 238.64 276.1 205.18 294.28 200.51 291.72 188.58 298.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,185.1s7,5.44,9.78,11.6,8.16,17.06,8.16,17.06l27-16.61,7.86,15.24s-20.19,18.05-22.91,20.33c-3.69,3.1-6.14,4.67-9.93,4.67s-6.64-.53-10-5.47l-4.6-8.3Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,200.77a1.48,1.48,0,0,1,.11.48c.06.37.13.83.22,1.38.18,1.21.43,3,.71,5.11.57,4.32,1.29,10.3,2,16.91s1.23,12.61,1.57,16.95c.17,2.18.3,3.93.37,5.15,0,.56.05,1,.07,1.4a1.68,1.68,0,0,1,0,.49,3.06,3.06,0,0,1-.09-.48c0-.37-.09-.83-.16-1.39-.13-1.29-.31-3-.52-5.13-.45-4.4-1.05-10.36-1.72-16.94s-1.36-12.52-1.83-16.91l-.56-5.13c-.05-.56-.09-1-.13-1.4A2.6,2.6,0,0,1,271.44,200.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,205.39c-.09,0,0-1.3-.44-3.33a16.33,16.33,0,0,0-9.79-12c-1.91-.81-3.21-1-3.19-1.09a3,3,0,0,1,.91.09,14.5,14.5,0,0,1,2.4.67A15.74,15.74,0,0,1,224,202a13.94,13.94,0,0,1,.18,2.49A2.77,2.77,0,0,1,224.12,205.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.39,258.2a6.05,6.05,0,0,1-1.22-.18,28.55,28.55,0,0,1-3.28-.82,38.18,38.18,0,0,1-4.7-1.77,43.08,43.08,0,0,1-5.38-3,42.34,42.34,0,0,1-4.87-3.76,38.06,38.06,0,0,1-3.49-3.6,30,30,0,0,1-2.06-2.68,6,6,0,0,1-.65-1.06c.08-.05,1.08,1.4,3,3.51a45.1,45.1,0,0,0,3.53,3.5,48.53,48.53,0,0,0,4.84,3.68,47.45,47.45,0,0,0,5.3,3,45.14,45.14,0,0,0,4.61,1.85C264.68,257.77,266.41,258.1,266.39,258.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.46,296.51l.48,5.48s4.21,2.2,5.72,3.74,5.92,9.72,5.92,9.72a2.32,2.32,0,0,1-3,.21,36.47,36.47,0,0,1-3.1-4.35h0a2.36,2.36,0,0,0-2.76,2.84c.57,2.45,1.22,5.31,1.23,5.69s2.46,2.73,4.3,4.42A1.57,1.57,0,0,1,231,327a.66.66,0,0,1-.37-.19s.21,2.61-3.38.53c0,0-3.18.77-4.74-1,0,0-3.92-.54-5.31-1.67s-4.51-13-4.51-13L210.9,299Z",
    style: {
      fill: "#bd8c83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.14,315.5a7.23,7.23,0,0,0,.05,2.15,11.23,11.23,0,0,0,1.55,5,10,10,0,0,0,4,3.24,6.91,6.91,0,0,0,2,.78,9.63,9.63,0,0,0-1.78-1.12,11.29,11.29,0,0,1-3.72-3.22,12.6,12.6,0,0,1-1.62-4.7A10,10,0,0,0,223.14,315.5Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.44,316.94a4.13,4.13,0,0,0-.05,2,13.14,13.14,0,0,0,.4,2.1,6.54,6.54,0,0,0,1.12,2.41,11.07,11.07,0,0,0,2,1.7l1.69,1.2a6.67,6.67,0,0,0,1.64,1c.05-.07-.49-.56-1.4-1.32-.46-.38-1-.83-1.62-1.3a12.33,12.33,0,0,1-1.85-1.66,6.65,6.65,0,0,1-1.05-2.2c-.23-.74-.39-1.43-.51-2C220.53,317.68,220.52,316.94,220.44,316.94Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.46,318.85c-.22,0,.33,2.17,1.16,4.66a2.12,2.12,0,0,0,.6.89,5.38,5.38,0,0,0,.69.6,7.73,7.73,0,0,0,1.28.84c.78.41,1.33.5,1.35.43s-.45-.29-1.14-.77a12,12,0,0,1-1.17-.9,8.53,8.53,0,0,1-.62-.59,1.71,1.71,0,0,1-.47-.68c-.4-1.27-.82-2.38-1.12-3.19A6.27,6.27,0,0,0,217.46,318.85Z",
    style: {
      fill: "#896360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,188.52s-7.57,9.4-7.63,17.08-1.64,57.25-1.64,57.25l10.6,41.32,16.9-4.28-6-43.53.58-37.8Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,304.17a.87.87,0,0,1,.29-.1l.87-.25,3.36-.9,12.33-3.21-.14.21c-1.27-8.71-3-20.26-4.79-32.9-.43-3-.86-5.95-1.26-8.77v0c.2-11.87.39-22.32.52-29.83.08-3.71.15-6.7.2-8.8,0-1,.06-1.79.08-2.37,0-.25,0-.45,0-.61s0-.21,0-.21,0,.07,0,.21,0,.36,0,.61v2.37c0,2.1,0,5.09-.05,8.8-.09,7.52-.22,18-.36,29.84v0c.4,2.82.83,5.76,1.26,8.77,1.8,12.65,3.44,24.2,4.68,32.92l0,.16-.16,0-12.37,3.05-3.38.8-.89.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23,259.7A55.71,55.71,0,0,0,270,263.91c-1.08,1.63-3.12,2-5.07,2.16a15.92,15.92,0,0,1-5.71-.55c-3.58-1.1-7.79-2.77-10-5.82"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.71,213.76a29.76,29.76,0,0,0-.26,11.44,2.92,2.92,0,0,0,.57,1.59,1,1,0,0,0,1.51.09,1.54,1.54,0,0,0,0-1.39c-1.43-4.72-2.06-6.81-1.84-11.73"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.17,218.56c-2.26,24.45.44,48.46,4.23,73.16l1.19,8.17C227.89,275.51,225.9,242.52,221.17,218.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M221.41,220.3a4.39,4.39,0,0,1-.71-.81,15.87,15.87,0,0,0-2-2.14,5.78,5.78,0,0,0-3.81-1.53,4,4,0,0,0-2.26.81c-.71.49-1.35,1.15-2.1,1.77a5.45,5.45,0,0,1-2.56,1.28,5.24,5.24,0,0,1-2.66-.26,6.42,6.42,0,0,1-3.38-2.85,9.59,9.59,0,0,1-1.08-2.78,3,3,0,0,1-.12-1.08,6.52,6.52,0,0,1,.32,1,10.64,10.64,0,0,0,1.19,2.63,6.2,6.2,0,0,0,3.22,2.6,4.81,4.81,0,0,0,2.42.21,4.92,4.92,0,0,0,2.32-1.19c.72-.59,1.38-1.25,2.14-1.78a4.47,4.47,0,0,1,2.54-.87,6,6,0,0,1,4.06,1.74,12.59,12.59,0,0,1,1.9,2.29A3.93,3.93,0,0,1,221.41,220.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,254.64s-.18.26-.58.65a19,19,0,0,1-1.79,1.56,27.08,27.08,0,0,1-14.42,5.58,18.26,18.26,0,0,1-2.37.05,2.82,2.82,0,0,1-.86-.09c0-.09,1.23-.09,3.2-.33a30.54,30.54,0,0,0,14.23-5.51C218.73,255.41,219.64,254.57,219.7,254.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,283.19c0,.09-1.13-.08-2.91,0a18.56,18.56,0,0,0-3.09.41,20.69,20.69,0,0,0-3.61,1.21,21.06,21.06,0,0,0-3.3,1.92,19.68,19.68,0,0,0-2.35,2.05c-1.23,1.29-1.84,2.23-1.92,2.18s.1-.27.37-.7a12.17,12.17,0,0,1,1.28-1.73,16.29,16.29,0,0,1,2.34-2.18,18.32,18.32,0,0,1,3.36-2,18.76,18.76,0,0,1,3.73-1.21,16.06,16.06,0,0,1,3.19-.31,11.5,11.5,0,0,1,2.14.17A2.31,2.31,0,0,1,223.56,283.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.29,211.57s-.67.63-1.61,2a39.5,39.5,0,0,0-3.12,6.26,22.58,22.58,0,0,1-2.38,4.28,8.43,8.43,0,0,1-4.61,3.19,10.74,10.74,0,0,1-3.06.25,24.52,24.52,0,0,1-3.15-.42,32.23,32.23,0,0,0-6.48-.9,8.39,8.39,0,0,0-3.15.68,8,8,0,0,0-2.52,1.87,31.7,31.7,0,0,0-3.4,5,16.6,16.6,0,0,1-3.49,4.41,10.57,10.57,0,0,1-4.42,2.11,11,11,0,0,1-7-.72,7.39,7.39,0,0,1-2.16-1.42,15.41,15.41,0,0,0,2.24,1.24,11.1,11.1,0,0,0,6.8.54,10.32,10.32,0,0,0,4.23-2.08,16.64,16.64,0,0,0,3.35-4.32,31.08,31.08,0,0,1,3.44-5.16,8.41,8.41,0,0,1,2.67-2,9,9,0,0,1,3.36-.73,32.22,32.22,0,0,1,6.59.92,26,26,0,0,0,3.07.43,10.4,10.4,0,0,0,2.92-.23,8.07,8.07,0,0,0,4.39-3,21.93,21.93,0,0,0,2.38-4.16,35.43,35.43,0,0,1,3.3-6.23A8.75,8.75,0,0,1,272.29,211.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.72,186.59a1.5,1.5,0,0,1,.17.49,4.44,4.44,0,0,1,0,1.51,6.62,6.62,0,0,1-3.12,4.42c-2,1.28-4.94,1.55-8,1.41-1.52,0-3.11-.15-4.75-.06a11,11,0,0,0-4.81,1.24,14.91,14.91,0,0,0-3.75,3.32,32.57,32.57,0,0,1-3.29,3.51,11.69,11.69,0,0,1-7.59,2.73,11.85,11.85,0,0,1-5.33-1.24,8.9,8.9,0,0,1-1.27-.79c-.27-.2-.41-.31-.4-.33s.6.4,1.76.94a12.29,12.29,0,0,0,5.24,1,11.43,11.43,0,0,0,7.28-2.73,32.91,32.91,0,0,0,3.22-3.47,14.89,14.89,0,0,1,3.88-3.45,11.49,11.49,0,0,1,5-1.29,47,47,0,0,1,4.8.1c3,.16,5.81-.08,7.76-1.26a6.51,6.51,0,0,0,3.11-4.14A6,6,0,0,0,266.72,186.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,261.72a5.42,5.42,0,0,0-1.88-1.39,6.93,6.93,0,0,0-6.11.68,17.24,17.24,0,0,0-3.4,2.83,48.72,48.72,0,0,1-3.67,3.65,9.71,9.71,0,0,1-5.2,2.47,11.87,11.87,0,0,1-6-1.33c-1.93-.87-3.71-1.87-5.55-2.54a25.62,25.62,0,0,0-5.47-1.33,26.74,26.74,0,0,0-9.51.47,26.17,26.17,0,0,0-6.06,2.22c-1.36.69-2.07,1.17-2.1,1.12a3.11,3.11,0,0,1,.5-.37,15.9,15.9,0,0,1,1.51-.93,24.16,24.16,0,0,1,6.07-2.39,26.33,26.33,0,0,1,9.65-.6,26,26,0,0,1,5.59,1.33c1.88.68,3.69,1.69,5.58,2.55a11.36,11.36,0,0,0,5.77,1.29,9.15,9.15,0,0,0,4.94-2.33c1.39-1.14,2.52-2.44,3.68-3.58a16.82,16.82,0,0,1,3.52-2.85,7,7,0,0,1,6.38-.54,4.11,4.11,0,0,1,1.43,1.06,2,2,0,0,1,.28.37C278,261.67,278.06,261.71,278.05,261.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.49,174.82s-1.27-2.75-.64-4.36,1.22-1.72,1.22-1.72l25.31,8.4a4,4,0,0,1,0,4.41c-1.45,2.61-8.52,2.61-8.52,2.61Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.38,181.55a3.78,3.78,0,0,1-1.07.41,13.1,13.1,0,0,1-3.11.45,27.36,27.36,0,0,1-10.09-2,47.2,47.2,0,0,1-9.15-4.74c-1.1-.71-2-1.31-2.59-1.73a4.84,4.84,0,0,1-.9-.71,5.21,5.21,0,0,1,1,.54l2.68,1.59a55.87,55.87,0,0,0,9.13,4.56,29.35,29.35,0,0,0,9.9,2.17A23.1,23.1,0,0,0,257.38,181.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.59,226.31a12.34,12.34,0,0,0,.2-3.28,7.53,7.53,0,0,0-4.47-6c-1.39-.6-3-.73-4.21-1.46a5.1,5.1,0,0,1-2.27-2.93,5,5,0,0,1-.13-2.49,2,2,0,0,1,.34-.85,4.93,4.93,0,0,1-.14.89,5.26,5.26,0,0,0,.28,2.34,4.78,4.78,0,0,0,2.15,2.62c1.15.65,2.68.76,4.19,1.4a7.93,7.93,0,0,1,3.45,3,7.52,7.52,0,0,1,1.17,3.5,7.23,7.23,0,0,1-.22,2.48A2.29,2.29,0,0,1,302.59,226.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,221a4.81,4.81,0,0,0,1.44-1.13c.74-.85,1.1-2.46,1.94-4.08a16.59,16.59,0,0,1,2.65-3.79,5.21,5.21,0,0,1,1.45-1.25,35.69,35.69,0,0,0-3.64,5.28c-.8,1.54-1.23,3.18-2.13,4.08S273.83,221,273.84,221Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.07,230.92a83.17,83.17,0,0,0,.79-13.65,28.94,28.94,0,0,0-3.51-13.09q.64,13.31,2.08,26.55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5,182.28c-.08-.49-1-.21-1.5-.18-7.57.41-16.94-3.29-23.05-8.35,3.86,4.72,9,9,14.78,10.88a12.88,12.88,0,0,0,5.13.75,5.93,5.93,0,0,0,4.43-2.43A.93.93,0,0,0,256.5,182.28Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.38,469.45c0,.14-148.38.26-331.36.26s-331.4-.12-331.4-.26,148.35-.26,331.4-.26S706.38,469.31,706.38,469.45Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.aa8b6f3f9a405adf193f300a5772714c.svg";
export { ForwardRef as ReactComponent };